import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_Close from '../Assets/Icons/Icon_Close.png';
import Icon_Success from '../Assets/Icons/Icon_Color_Success.png';
import { Context_UI } from '../Contexts/Context_UI';

export default function Subwindow_Modal_Register_Verified({ zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const Navigate = useNavigate();
    const Confirm = () => {
        UI.Subwindows_Close('Window_Register_Verified');
        Navigate("/");
    }

    useEffect(() => {
        const el = document.getElementById("Window_Register_Verified");
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);

    return (
        <ui-subwindow Type='Modal' id='Window_Register_Verified' State='Inactive' Visibility='Close'>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    
                </h2>
                <button className='Subwindow_TitleBar_Control'>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Success} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>

                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Account verified!
                </h2>
                
                <p className='General_Paragraph' style={{textAlign: "center", marginBottom: "10px"}}>
                    Please wait for the administrator to approve your account.
                </p>
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Confirm}>
                    Close
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
